export const SET_USER_TYPE = 'SET_USER_TYPE';
export const SET_PROPS = 'SET_PROPS';


export const setUserType = (payload) => dispatch => {
    dispatch({
        type: SET_USER_TYPE,
        payload
    });
};

export const setProps = (payload) => dispatch => { 
  dispatch({
      type: SET_PROPS,
      payload
  });
};


// WEBPACK FOOTER //
// ./src/actions/ads.js